const c = "https://checkout.razorpay.com/v1/checkout.js";
export {
  c as RAZORPAY_SCRIPT
};
